import { SearchMagnifyingGlassIcon } from '@forwardflow/icons'

interface PhoneNumberSearchInputProps {
   value: string
   onChange: (value: string) => void
   placeholder?: string
   className?: string
}

export const PhoneNumberSearchInput = ({
   value,
   onChange,
   placeholder = 'Search Phone numbers',
   className = '',
}: PhoneNumberSearchInputProps) => {
   return (
      <div className={`relative w-full max-w-[calc(100%-12px)] ${className}`}>
         <SearchMagnifyingGlassIcon className="absolute left-4 top-1/2 -translate-y-1/2 text-white/40 w-5 h-5 pointer-events-none" />
         <input
            type="text"
            value={value}
            onChange={(e) => onChange(e.target.value)}
            placeholder={placeholder}
            className="w-full h-14 pl-12 pr-4 bg-[#9061DA]/10 text-white placeholder:text-white/40 focus:outline-none focus:ring-2 focus:ring-[#9061DA]/50 transition-all"
         />
      </div>
   )
}
